import React from 'react'
import { Rings } from 'react-loading-icons'

const Shop = () => {
  return (
    <div className='h-[80dvh] w-full flex flex-col items-center justify-center relative'>
        <h6 className='md:text-[70px] text-[40px] text-[#9e9a83] font-[800]'>Coming soon</h6>
        <p className='text-[#9e9a83] text-center'>Shopping page coming soon. Anticipate all our coming products!</p>
        <Rings stroke='#000'/>
    </div>
  )
}

export default Shop